<template>
  <div v-loading="convertLoading">
    <v-container v-if="isDropboxVisible">
      <v-layout row wrap>
        <v-flex xs12 md12>
          <div class="dropbox">
            <input
              type="file"
              ref="file"
              multiple
              @change="filesChange($event.target.name, $event.target.files);"
              accept="image/*, .pdf"
              class="input-file"
            />
            <p>
              將圖片或PDF(一張或多張)拖到此處
              <br />或點擊合併
            </p>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-layout v-if="uploadedFiles.length > 0" row wrap>
      <v-flex xs12 md12>
        <v-card>
          <v-container fluid
            grid-list-md
          >
            <v-layout row wrap>
              <v-flex
                v-for="file in uploadedFiles"
                :key="`${file.caseId}`"
                v-bind="{ [`xs3`]: true }"
              >
                <v-card>
                  <v-img
                    :src="file.file_body_encode"
                    height="200px"
                    contain
                    @click="selectImage(file)"
                  >
                  <div v-if="file.file_index > 0" class="selectedIamge white--text" v-text="file.file_index"></div>
                  </v-img>
                  <v-card-actions>
                      <v-layout fill-height>
                        <v-flex xs12>
                          <span v-text="file.name"></span>
                        </v-flex>
                      </v-layout>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="editImage(file)">
                      <v-icon large color="indigo darken-2">edit</v-icon>
                    </v-btn>
                    <v-btn icon @click="removeImage(file.caseId)">
                      <v-icon large color="red darken-2">delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <v-container>
      <v-layout v-if="uploadedFiles.length > 0">
        <v-flex>
          <v-btn color="primary" @click="convertPdf">合併成PDF</v-btn>
        </v-flex>
         <v-flex>
          <v-btn color="primary" @click="convertZip">匯出Zip檔</v-btn>
        </v-flex>
        <v-flex>
          <v-btn color="error" @click="deletePdfArray">一鍵清除</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <image-editor-view 
      :visible="imageEditor.visible"
      :image-item="imageEditor.imageItem"
      @confirmEvent="imageEditor.confirm"
      @closeEvent="closeDialogView"
      @cropperEvent="cropperEvent"
      ></image-editor-view>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {exportPdf} from '../pages/utils/tool';
import download from 'downloadjs';
import AttachmentModel from '../models/AttachmentModel';
import PDF from 'pdfjs-dist';
import ImageEditorView from '../components/ImageEditorView';
import JSZip from 'jszip';

// PDF.GlobalWorkerOptions.workerSrc = 'pdfjs-dist/build/pdf.worker.js';
// PDF.workerSrc = "pdfjs-dist/build/pdf.worker.js";
// PDF.disableWorker = true;
export default {
  
  props: ['pdfName', 'isDownload'],
  name: "PdfConvertView",
  components:{ ImageEditorView },
  data() {
    return {
      uploadedFiles: [],
      convertLoading:false,
      width: 100,
      pdfDoc: null,
      pages: 0,
      pdfNmae:'',
      imageEditor: {
          visible: false,
          imageItem: null,
          confirm:()=>{},
          cancel:()=>{},
      },
      isDropboxVisible:true,
    };
  },
  watch: {},
  computed: {
    
  },  
  created() {
    // this.loadFile(`https://pdf-lib.js.org/assets/with_update_sections.pdf`);
    // this.loadFile(`https://pdf-lib.js.org/assets/us_constitution.pdf`);
  },
  methods: {
    cropperEvent(info){
      let itemInfo = this.uploadedFiles.find(u=>u.caseId == info.caseId);
      itemInfo.file_body_encode = info.file_body_encode;
    },
    removeImage(caseId) {
      const copy = JSON.parse(JSON.stringify(this.uploadedFiles));
      copy.forEach((item, index) => {
        if (item.caseId === caseId) {
          this.uploadedFiles.splice(index, 1);
        }
      });
      if (this.uploadedFiles.length === 0) {
        this.$refs.file.value = null;
      }
    },
    editImage(file) {
      this.isDropboxVisible = false;
      this.imageEditor.visible = true;
      this.imageEditor.imageItem = file;
      this.imageEditor.confirm = ()=> {
        this.imageEditor.visible = false;
        this.isDropboxVisible = true;
      };
    },
    closeDialogView(){
      this.imageEditor.visible = false;
      this.isDropboxVisible = true;
    },
    async convertZip() {
      this.convertLoading = true;
      const selectedArray = this.uploadedFiles.filter((item, index) => {
          return item.file_index > 0;
      });
      const uploadedArray = selectedArray.length > 0 ? selectedArray.sort((a, b) => {
        return ( a.file_index < b.file_index) ? -1 : 0;
      }) : this.uploadedFiles;
      console.log(`uploadedArray === ${JSON.stringify(uploadedArray)}`)
      const fileName = `${new Date().getTime()}.zip`

      const zip = new JSZip();
      for (let file of uploadedArray){
        const info = file.file_body_encode.replace(/^data:image\/(png|jpg);base64,/, "")
        zip.file(file.name + `.png`, info, {base64: true});
      }
      
      const self = this;
      const zipFile = await zip.generateAsync({type : 'blob'}).then(function(content) {
          self.convertLoading = false;
          // saveAs(content, "example.zip");
          download(content, fileName, "application/zip");
      });

      

      
    },
    async convertPdf() {
      this.convertLoading = true;
      const selectedArray = this.uploadedFiles.filter((item, index) => {
          return item.file_index > 0;
      });
      const uploadedArray = selectedArray.length > 0 ? selectedArray.sort((a, b) => {
        return ( a.file_index < b.file_index) ? -1 : 0;
      }) : this.uploadedFiles;
      
      const pdfFile = await exportPdf(uploadedArray);
      this.convertLoading = false;
      if(this.isDownload){
        // Trigger the browser to download the PDF document
        const name = this.pdfNmae ? this.pdfNmae : Math.uuidFast();
        const fileName = `${name}.pdf`;
        download(pdfFile, fileName, "application/pdf");
      } else {
        this.$emit('onFinishConvert', pdfFile);
      }
    },
    deletePdfArray(){
      this.uploadedFiles = [];
      this.$refs.file.value = null;
    },
    filesChange(fieldName, fileList) { 
      const files = Object.values(this.$refs.file.files);
      if (!fileList.length) return;

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((i, x) => {
          const file = {
            name: fileList[x].name,
            image: fileList[x],
            size: fileList[x].size,
            type: fileList[x].type,
          };

          this.createImage(i, file, fileList.length - 1);
        });
    },
    createImage(i, file, total) {
      const reader = new FileReader();
      const fileName = file.name;
      const fileType = this.getFileType(file.type);
      
      reader.onload = (e) => {
        const data = e.target.result;
        
        if(fileType === 'pdf'){
          this.pdfConvertImage(data, fileName);
        } else {
          let attachmentItem = new AttachmentModel();
            attachmentItem.caseId = Math.uuidFast();
            attachmentItem.file_index = 0;
            attachmentItem.file_body_encode = data;
            attachmentItem.file_size = data.length;
            attachmentItem.content_type = fileType;
            attachmentItem.name = fileName;
          this.uploadedFiles.push(attachmentItem);
        }
      };
      reader.readAsDataURL(file.image);
    },
    getFileType(type) {
      const name = type.toLowerCase();
      if (name.indexOf('jpeg') > -1 || name.indexOf('jpg') > -1) {
        return 'jpg';
      }
      if (name.indexOf('png') > -1) {
        return 'png';
      }
      if (name.indexOf('pdf') > -1) {
        return 'pdf';
      }
      return 'zip';
    },
    /*
    * 加载PDF文件
    * url：后台提供的pdf地址或者项目中public/pdf文件（test.pdf）
    * 在需要的位置调用 this.loadFile(url)
    * */
    loadFile (url) {      
      PDF.getDocument(url).then((pdf) => {
          this.pdfDoc = pdf
          this.pages = this.pdfDoc.numPages
          this.$nextTick(() => {
            this.renderPage(1)
        })
      })
    },
    /*
    * 渲染PDF文件
    * */
    renderPage (num) {
      this.pdfDoc.getPage(num)
        .then((page) => {
          let canvas = document.getElementById('canvas' + num)
          let ctx = canvas.getContext('2d')
          let dpr = window.devicePixelRatio || 1 // 设备像素比
          let bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1 // 浏览器在渲染canvas之前会用几个像素来来存储画布信息,类似img
          let ratio = dpr / bsr
          let viewport = page.getViewport(1)
          canvas.width = viewport.width * ratio // 画布大小,默认值是width:300px,height:150px
          canvas.height = viewport.height * ratio
          canvas.style.width = viewport.width + 'px' // 画布的框架大小
          canvas.style.height = viewport.height + 'px'
          let renderContext = {
            canvasContext: ctx,
            viewport: viewport
          }
          page.render(renderContext)
      })
    },
    pdfConvertImage(file, name) {
      const loadingTask = PDF.getDocument(file);
      loadingTask.promise.then((pdf) => {
        
        const pages = pdf.numPages;
        let promiseArray = [];
        for(let num = 1; num <= pages; num++) {
          promiseArray.push(num);
        }
        
        const delayPromise = num =>
          new Promise((resolve, reject) => {
            pdf.getPage(num).then((page) => {
              let canvas = document.createElement('canvas')
              let ctx = canvas.getContext('2d')
              let dpr = window.devicePixelRatio || 1 // 设备像素比
              let bsr = ctx.webkitBackingStorePixelRatio || ctx.mozBackingStorePixelRatio || ctx.msBackingStorePixelRatio || ctx.oBackingStorePixelRatio || ctx.backingStorePixelRatio || 1 // 浏览器在渲染canvas之前会用几个像素来来存储画布信息,类似img
              let ratio = dpr / bsr
              let viewport = page.getViewport({scale:2});
              canvas.width = viewport.width
              canvas.height = viewport.height
              let renderContext = {
                canvasContext: ctx,
                viewport: viewport
              }
              const renderTask = page.render(renderContext);
              renderTask.promise.then(() => {          
                const dataURL = canvas.toDataURL();
                const fileName = `${name.split('.').slice(0, -1).join('.')}-第${num}頁`;
                let attachmentItem = new AttachmentModel();
                  attachmentItem.caseId = Math.uuidFast();
                  attachmentItem.file_index = 0;
                  attachmentItem.file_body_encode = dataURL;
                  attachmentItem.file_size = dataURL.length;
                  attachmentItem.content_type = `png`;
                  attachmentItem.name = fileName;
                this.uploadedFiles.push(attachmentItem);
                resolve();
              }).catch(reason => {
                console.log(reason.message);
                reject(reason.message);
              });
            });
          });

        const reduceFunc = async (reducer, initVal, dataArray) => {
          let val = initVal;
          for(const i in dataArray) {
            val = reducer(val, dataArray[i]);
          }
          return val;
        }
        reduceFunc(
          async(acc, current) => {
            await acc;
            return await delayPromise(current);
          }, 
          Promise.resolve, promiseArray
        )
      });
    },    
    selectImage(file){
      if(file.file_index > 0) {
        const indexVulue = file.file_index;
        this.uploadedFiles.forEach((item, index) => {
          if (item.file_index > file.file_index) {
            item.file_index = item.file_index - 1;
          }
        });
        file.file_index = 0;
        
      } else {
        const selected = this.uploadedFiles.filter((item, index) => {
          return item.file_index > 0;
        });
        file.file_index = selected.length + 1;
        selected.sort((a, b) => {
          a.file_index - b.file_index;
        });
        selected.forEach((item, index) => {
          console.log(`${file.name}`);
          console.log(`${file.file_index}`);
        });
      }
    },
  },
};
</script>

<style scoped>
.pdf-container{
    width: 100%;
    height: 100%;
    position: absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
  }

.imgBox {
  box-shadow: 4px 4px 12px -2px rgba(20%, 20%, 40%, 0.5);
}

.image-view {
  width: 100%;
  height: 180px;
  object-fit: scale-down;
}

.image-title {
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
  display: block;
  overflow: hidden;
}

.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: white;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
}

.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}

.dropbox:hover {
  background: white;
}

.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
.selectedIamge {
  border-radius: 50%;
  background-color: #44ad53;
  height: 30px;
  width: 30px;
  position: absolute;
  top: 5px;
  right: 5px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/PdfConvertView.vue